import { render, staticRenderFns } from "./approveGoods.vue?vue&type=template&id=2e15d505&scoped=true"
import script from "./approveGoods.vue?vue&type=script&lang=js"
export * from "./approveGoods.vue?vue&type=script&lang=js"
import style0 from "./approveGoods.vue?vue&type=style&index=0&id=2e15d505&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e15d505",
  null
  
)

export default component.exports